import { Box, Stack, Text } from '@ltvco/refresh-lib/theme';

import { CLASS_ACTION_REPORT_SECTION_IDS } from '../shared/constants';
import { DesktopReportSection } from '../shared/DesktopReportSection';

import type { DocketDetailNextStepsSection } from '../types';

function NextStepRow({
  stepNumber,
  text,
  isLast,
}: {
  stepNumber: number;
  text: string;
  isLast: boolean;
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'stretch',
        gap: 3.75,
        minHeight: isLast ? undefined : 76,
      }}
    >
      <Text
        sx={{
          alignSelf: 'flex-start',
          flexShrink: 0,
          fontFamily: "'Nunito Sans', sans-serif",
          fontSize: 16,
          fontWeight: 700,
          lineHeight: '24px',
          color: 'text.primary',
        }}
      >
        {stepNumber}
      </Text>
      <Box
        sx={{
          display: 'flex',
          width: '12px',
          flexShrink: 0,
          flexDirection: 'column',
          alignItems: 'center',
          pt: 0.75,
        }}
      >
        <Box
          sx={{
            width: '12px',
            height: '12px',
            flexShrink: 0,
            borderRadius: '50%',
            bgcolor: 'primary.main',
          }}
        />
        {!isLast ? (
          <Box
            sx={{
              width: '1px',
              minWidth: '1px',
              maxWidth: '1px',
              flex: '1 1 auto',
              minHeight: 50,
              mt: 1,
              flexShrink: 0,
              bgcolor: 'primary.main',
            }}
          />
        ) : null}
      </Box>
      <Text
        sx={{
          alignSelf: 'flex-start',
          flex: 1,
          fontFamily: "'Nunito Sans', sans-serif",
          fontSize: 16,
          fontWeight: 400,
          lineHeight: '24px',
          color: 'text.primary',
        }}
      >
        {text}
      </Text>
    </Box>
  );
}

export function NextStepsSection({
  next_steps,
}: {
  next_steps: DocketDetailNextStepsSection;
}) {
  const steps = (next_steps.steps ?? []).map((s) => s.trim()).filter(Boolean);

  if (!steps.length) {
    return null;
  }

  return (
    <DesktopReportSection
      title="Next Steps"
      sectionId={CLASS_ACTION_REPORT_SECTION_IDS.next_steps}
    >
      <Stack spacing={1.5}>
        {steps.map((text, index) => (
          <NextStepRow
            key={`${index}-${text.slice(0, 48)}`}
            stepNumber={index + 1}
            text={text}
            isLast={index === steps.length - 1}
          />
        ))}
      </Stack>
    </DesktopReportSection>
  );
}
